<template>
	<view class="box">
		<view class="box_info">
			<image src="@/static/icon/ic_success@2x.png" mode="widthFix"></image>
			<view class="box_info_title">提交成功</view>
			<view class="box_info_text">可在”首页-我的保单“中查看投保进度</view>
			<view class="box_info_footer">
				<u-button type="primary" shape="circle" color="#999999" :plain="true" text="回到首页" @click="goIndex"></u-button>
				<view class="box_info_footer_zw"></view>
				<u-button type="primary" shape="circle" color="#437CB3" :plain="true" text="查看订单" @click="toOrder"></u-button>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				orderId: null
			};
		},
		onLoad(option) {
			this.orderId = option.orderId
		},
		methods: {
			goIndex() {
				uni.switchTab({
					url: '/pages/index/index'
				})
			},
			toOrder() {
				uni.navigateTo({
					url: `/pages/policyDetails/policyDetails?orderId=${this.orderId}`
				})
			}
		}
	}
</script>
<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100vw;
		height: 100vh;
		padding: 20rpx 30rpx;
		box-sizing: border-box;
		.box_info {
			width: 100%;
			height: 100%;
			background-color: #ffffff;
			display: flex;
			align-items: center;
			flex-direction: column;
			border-radius: 16rpx;
			padding-top: 140rpx;
			box-sizing: border-box;
			image {
				width: 180rpx;
				height: 180rpx;
			}
			.box_info_title {
				width: 100%;
				text-align: center;
				margin-top: 32rpx;
				font-weight: 500;
				font-size: 36rpx;
				color: #220000;
				font-style: normal;
			}
			.box_info_text {
				width: 100%;
				text-align: center;
				margin-top: 20rpx;
				font-weight: 400;
				font-size: 26rpx;
				color: #999999;
				font-style: normal;
			}
			.box_info_footer {
				width: 70%;
				display: flex;
				justify-content: space-between;
				margin-top: 76rpx;
				.box_info_footer_zw {
					width: 48rpx;
					height: 100%;
				}
			}
		}
	}
</style>
